import React from 'react';

const ReRun = ({ width = '16', height = '16', className = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <path
        d="M6.0013 8.83464L2.66797 5.5013L6.0013 2.16797"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66797 5.5H9.66797C10.1495 5.5 10.6263 5.59484 11.0711 5.77911C11.516 5.96338 11.9202 6.23346 12.2607 6.57394C12.6012 6.91442 12.8713 7.31863 13.0555 7.76349C13.2398 8.20835 13.3346 8.68515 13.3346 9.16667C13.3346 9.64818 13.2398 10.125 13.0555 10.5698C12.8713 11.0147 12.6012 11.4189 12.2607 11.7594C11.9202 12.0999 11.516 12.37 11.0711 12.5542C10.6263 12.7385 10.1495 12.8333 9.66797 12.8333H7.33464"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33073 13.5013C4.69892 13.5013 4.9974 13.2028 4.9974 12.8346C4.9974 12.4664 4.69892 12.168 4.33073 12.168C3.96254 12.168 3.66406 12.4664 3.66406 12.8346C3.66406 13.2028 3.96254 13.5013 4.33073 13.5013Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReRun;
